"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailAttachment = void 0;
class EmailAttachment {
    fileName;
    content;
}
exports.EmailAttachment = EmailAttachment;
//# sourceMappingURL=EmailAttachment.js.map